import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";
import config from "./config";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Auth0Provider
        domain={config.AUTH0_DOMAIN}
        clientId={config.AUTH0_CLIENT_ID}
        authorizationParams={{
            audience: config.AUTH0_AUDIENCE,
            redirect_uri: window.location.origin,
        }}
    >
        <Router>
            <App />
        </Router>
    </Auth0Provider>
);
